import { IconType } from "react-icons/lib";
import { TbLockAccess, TbLockAccessOff } from "react-icons/tb";

import { softColors } from "./colors";

export type UserLoginStatusListItem = {
    component: () => IconType;
    hover: string;
    bg: string;
    label: string;
    text: string;
    tooltip: {
        title: string;
        description: string;
    };
    value: boolean;
};

export type UserLoginStatusList = UserLoginStatusListItem[];

export const userLoginStatuses: UserLoginStatusList = [
    {
        label: "Giriş yapabilir",
        component: () => TbLockAccess,
        ...softColors.green,
        tooltip: {
            title: "Kullanıcı giriş yapabilir.",
            description: "Kullanıcı giriş yapıp işlemlerini gerçekleştirebilir.",
        },
        value: false,
    },
    {
        label: "Giriş yapamaz",
        component: () => TbLockAccessOff,
        ...softColors.brown,
        tooltip: {
            title: "Kullanıcı giriş yapamaz",
            description: "Kullanıcı pasif edildiğinden giriş yapamaz.",
        },
        value: true,
    },
];
